/* eslint-disable @typescript-eslint/no-inferrable-types */
import {
  ApproveUserRequest,
  IremboClientUsersData,
  IremboClientUsersPostData,
} from './../models/users/irembo-user-model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { IHttpPagedResponse } from '@irembo-andela/irembogov3-common';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  constructor(private http: HttpClient) {}

  getChangeRequest(
    roleType: string,
    queryStr: string
  ): Observable<IHttpPagedResponse<IremboClientUsersData>> {
    const headers: HttpHeaders = new HttpHeaders();
    const endpoint =
      ROLE_TO_ENDPOINT_MAP[roleType] ?? 'service-manager-request';
    return this.http.get<IHttpPagedResponse<IremboClientUsersData>>(
      `${environment.apiGatewayBaseUrl}/admin/v1/${endpoint}?${queryStr}`,
      { headers }
    );
  }

  getUsers(
    roleName: string,
    sortBy: string = 'createdOn',
    sortDirection: 'ASC' | 'DESC' = 'DESC',
    page: number = 0,
    size = 10
  ): Observable<any> {
    const headerParams: Record<string, string | string[]> = {
      sortBy,
      sortDirection,
    };
    const headers: HttpHeaders = new HttpHeaders(headerParams);

    return this.http.get<IHttpPagedResponse<IremboClientUsersData>>(
      `${environment.apiGatewayBaseUrl}/auth/v1/users/roles/${roleName}?page=${page}&size=${size}`,
      { headers }
    );
  }

  createServiceManagerRequest(createUserRequest: any): Observable<any> {
    const formData = new FormData();

    Object.keys(createUserRequest).forEach(key => {
      const data: string | Blob | undefined =
        createUserRequest[key as keyof IremboClientUsersPostData];
      if (data === undefined) return;
      formData.append(key, data);
    });

    const headers = new HttpHeaders({});
    return this.http.post(
      `${environment.apiGatewayBaseUrl}/admin/v1/service-manager-request`,
      formData,
      {
        headers,
      }
    );
  }

  initiateRequestToCreateQAReviewer(
    createUserRequest: any,
    path = 'qa-reviewer-request'
  ) {
    const headers = new HttpHeaders({});
    return this.http.post(
      `${environment.apiGatewayBaseUrl}/admin/v1/${path}`,
      createUserRequest,
      {
        headers,
      }
    );
  }

  approveOrRejectClientManagerRequest(
    request: ApproveUserRequest,
    roleType: string
  ): Observable<any> {
    const endpoint = ROLE_TO_ENDPOINT_MAP[roleType] ?? '';
    const url = `${environment.apiGatewayBaseUrl}/admin/v1/${endpoint}/take-action`;

    return this.http.patch(url, request);
  }
}

const ROLE_TO_ENDPOINT_MAP: Record<string, string> = {
  ROLE_SERVICE_MANAGER: 'service-manager-request',
  ROLE_QA_REVIEWER: 'qa-reviewer-request',
  ROLE_SUPER_SERVICE_PROVIDER: 'super-service-provider-request',
};
